export default {
  'menu.JuvenilesBlockReportListPage': '未成年人阻拦上报列表',
}